// La frise de la journée : l'idée du produit, en un dessin. Une barre qui va
// du ciel du matin au bleu de la nuit, et quatre moments posés dessus — le
// matin où tu poses le verrou, le couvre-feu, 2 h 47, le réveil. Les pins
// alternent dessus/dessous sur ordinateur ; sur téléphone la frise devient
// verticale.
import { useT } from '../../lib/i18n'

const PUB = process.env.PUBLIC_URL || ''

// Position de chaque pin sur la barre, en % — la barre court de 07:00 à
// 07:00 le lendemain (24 h).
const AT = [9, 66.5, 82, 100]

export default function Day () {
  const d = useT().day
  return (
    <section className="lp-day" aria-labelledby="lp-day-t">
      <div className="lp-wrap">
        <div className="lp-day__head lp-rv">
          <span className="lp-kicker">{d.kicker}</span>
          <h2 className="lp-h2 lp-day__t" id="lp-day-t">
            {d.t1} <img className="lp-glyph lp-glyph--sun" src={`${PUB}/media/dot-sun.webp`} alt="" width="360" height="360" /><br />
            {d.t2} <img className="lp-glyph lp-glyph--moon" src={`${PUB}/media/dot-moon.webp`} alt="" width="360" height="360" />
          </h2>
        </div>

        <div className="lp-day__line lp-rv">
          <div className="lp-day__bar" aria-hidden="true">
            {Array.from({ length: 25 }, (_, i) => <i key={i} style={{ left: `${(i / 24) * 100}%` }} className={i % 6 === 0 ? 'is-major' : ''} />)}
          </div>
          <ol className="lp-day__pins">
            {d.pins.map((p, i) => (
              <li key={p.time} className={`lp-pin lp-pin--${i % 2 ? 'down' : 'up'}${i === 2 ? ' lp-pin--night' : ''}`}
                style={{ '--at': `${AT[i]}%` }}>
                <span className="lp-pin__dot" aria-hidden="true" />
                <span className="lp-pin__card">
                  <span className="lp-pin__time">{p.time}</span>
                  <span className="lp-pin__who">{p.who}</span>
                  <b>{p.t}</b>
                  <span className="lp-pin__p">{p.p}</span>
                </span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
